
const tagsConstants = {
  PROMOTION: `promotion`,
  FEATURED: `featured`,
}

export { tagsConstants }
